import { Leaf, Heart, Award, Compass } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const VALUE_ICONS = [Heart, Leaf, Compass, Award];

export default function ChiSono() {
  const { t } = useTranslation();
  const values = t("about.values", { returnObjects: true });
  const formation = t("about.formation", { returnObjects: true });

  return (
    <div data-testid="page-chi-sono" className="max-w-7xl mx-auto px-5 sm:px-8 py-16 lg:py-24">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <img
            src="https://customer-assets.emergentagent.com/job_olistico-care/artifacts/l0hntxl2_IMG_2477.jpeg"
            alt="Valeria Cantore — Salute e Benessere"
            className="w-full h-[600px] object-cover rounded-[2rem]"
          />
        </div>

        <div className="lg:col-span-7 lg:pl-4">
          <div className="label-eyebrow mb-4">{t("about.eyebrow")}</div>
          <h1 className="font-serif text-5xl sm:text-6xl leading-[1.05] text-[#2C2F2A]">
            {t("about.title1")}<br />
            <em className="text-[#8A9A86] font-light">{t("about.title2")}</em>
          </h1>

          <div className="mt-10 space-y-6 text-lg text-[#5C6356] leading-relaxed">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
            <p>{t("about.p3")}</p>
          </div>

          <div className="mt-12 grid sm:grid-cols-2 gap-5">
            {values.map((v, i) => {
              const Icon = VALUE_ICONS[i] || Leaf;
              return (
                <div key={i} data-testid={`value-${i}`} className="card-soft p-6">
                  <Icon className="w-6 h-6 text-[#8A9A86] mb-3" strokeWidth={1.5} />
                  <div className="font-serif text-xl mb-1">{v.title}</div>
                  <p className="text-sm text-[#5C6356] leading-relaxed">{v.text}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-12 p-8 bg-[#F3F0EA] rounded-[2rem] border border-[#E6E2D8]">
            <div className="label-eyebrow mb-3">{t("about.formationTitle")}</div>
            <ul className="space-y-2 text-[#2C2F2A]">
              {formation.map((f, i) => <li key={i}>· {f}</li>)}
            </ul>
            <div className="grid grid-cols-2 gap-4 mt-6">
              <img
                src="https://customer-assets.emergentagent.com/job_olistico-care/artifacts/x48lv7d1_3980a25b-d26e-4e8b-9233-f9a502a70e93.jpeg"
                alt="Cerimonia certificazione Thai Massage"
                className="w-full h-44 object-cover rounded-2xl"
              />
              <img
                src="https://customer-assets.emergentagent.com/job_olistico-care/artifacts/mr7819fb_4079ce91-90f6-4cb2-ad92-8b74933a9efa.jpeg"
                alt="Trattamento di riflessologia plantare"
                className="w-full h-44 object-cover rounded-2xl"
              />
            </div>
          </div>

          <div className="mt-10 flex gap-4 flex-wrap">
            <Link to="/prenotazioni" data-testid="chisono-cta-book" className="btn-primary">{t("about.ctaBook")}</Link>
            <Link to="/contatti" data-testid="chisono-cta-contact" className="btn-secondary">{t("about.ctaContact")}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
